var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.merchandising.content && _vm.merchandising.content[_vm.type]
    ? _c(
        "div",
        { staticClass: "g-searchspring__merchandising" },
        _vm._l(_vm.merchandising.content[_vm.type], function (banner, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "g-searchspring__banner u-mb-s u-mb--m",
              class: {
                ["is-" + _vm.type]: true,
                "u-mt-s u-mt--m": _vm.type === "banner",
                "g-product-list-footer": _vm.type === "footer",
              },
            },
            [
              _c("div", {
                class: {
                  "g-product-list-header__image": _vm.type === "header",
                  "g-product-list-footer__content": _vm.type === "footer",
                },
                domProps: { innerHTML: _vm._s(banner) },
              }),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }